import React from 'react';
import ReactDOM from 'react-dom';
import '../../assets/css/modal.css';
import '../../assets/css/popup.css';
import {Title} from '@vds/typography';
import {Line} from '@vds/lines';
import {Button} from '@vds/buttons';

class PopupCallMeOneApp extends React.Component {
    constructor(props) {
        super(props);
        this.rootElement = document.getElementById('root');
        this.dialogWrapper = document.createElement('div');
    }

    componentDidMount() {
        this.rootElement.appendChild(this.dialogWrapper);
        const overlay = document.createElement('div');
        overlay.classList.add('modal');
        overlay.classList.add('page-overlay');
        this.dialogWrapper.appendChild(overlay);
        overlay.addEventListener('click', (e)=> {
            this.props.CloseCallBack();
        })
    }

    render() {
        return ReactDOM.createPortal(
            <DialogContent DialogHeader={this.props.DialogHeader} DialogRef={this.props.DialogRef} DialogStyle={this.props.DialogStyle} CloseCallBack={this.props.CloseCallBack}/>,
            this.dialogWrapper
          );
    }
}

export default PopupCallMeOneApp


const DialogContent = ({DialogHeader, DialogRef, DialogStyle, CloseCallBack}) => {
        return (
            <div className="PopupCallMe">
              <Title size="large"  bold viewport="mobile">Thank you</Title>

              <Line 
	type="heavy"
	inverted={false}
	/>

<Title size="medium"   viewport="mobile">Your call is scheduled far : </Title>
<Title size="small"  viewport="mobile">Today, as soon as agent is available</Title>
<Title size="medium"   viewport="mobile">Please remember times are approxitmate and may vary according to agent availability </Title>

<div className="submit_btn">
              {/* <a className="submit_button button p-50 " id="callmeButton" tabIndex="0" role="button" onClick={this.scheduleCall.bind(this)} onKeyDown={this.handleConfirmCall.bind(this)} data-track="Confirm">Confirm</a> */}
              <Button 
                   size="large"
                   inverted={false} 
                   disabled={false} 
                   secondary={false}
                   onClick={e => this.openDialogPopup()}>
                   Done
               </Button>;
           </div>

            </div>
             
        )
}





// WEBPACK FOOTER //
// ./src/components/modules/PopupCallMeOneApp.js